import React, { useState } from 'react';
import DownloadCellContent from '../../../../../../../components/Commons/Tables/DownloadCellContent/index';
import { EGTMTags } from '../../../../../../../store/commomTypes';
import { FabricationProjectsService } from '../../../../../../../services/FabricationProjects/index';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../../utils/Tagging';

interface DownloadProjectColumnState {
  fileBase64?: string;
  loading: boolean;
  error: boolean;
}

interface DownloadProjectColumnProps {
  contractNumber: string;
  projectId: number;
  fileName: string;
}

const DownloadProjectColumn: React.FC<DownloadProjectColumnProps> = ({
  contractNumber,
  projectId,
  fileName
}) => {
  const [downloadProjectState, setDownloadProjectState] =
    useState<DownloadProjectColumnState>({ loading: false, error: false });

  const dispatch = useDispatch();
  const { pathname } = location;
  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    pathname,
    true
  );

  const downloadProject = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    dispatch(
      sendTagging({
        screenName,
        itemName: 'button:baixar',
        event: 'click',
        itemDescription
      })
    );

    if (downloadProjectState.fileBase64) {
      downloadFile(downloadProjectState.fileBase64);
    } else {
      setDownloadProjectState({ loading: true, error: false });

      FabricationProjectsService.downloadProject(contractNumber, projectId)
        .then((fileBase64: string) => {
          if (fileBase64) {
            setDownloadProjectState({
              loading: false,
              error: false,
              fileBase64: fileBase64
            });
            downloadFile(fileBase64);
          } else {
            setDownloadProjectState({ loading: false, error: true });
          }
        })
        .catch((err) => {
          console.error(err);
          setDownloadProjectState({ loading: false, error: true });
        });
    }
  };

  const downloadFile = (fileBase64: string) => {
    const dataurl = 'data:text/plain;base64,' + fileBase64;
    const element = document.createElement('a');

    element.setAttribute('href', dataurl);
    element.setAttribute('download', `${fileName}`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <>
      <DownloadCellContent
        gtmClassName={EGTMTags.DOWNLOAD_PROJETO}
        onclick={downloadProject}
        loading={downloadProjectState.loading}
        error={downloadProjectState.error}
        justifyContent={'flex-start'}
      />
    </>
  );
};

export default DownloadProjectColumn;
